import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

class RealNavbar extends Component {
  render() {
    return (
      <>
      <Navbar bg="white" variant="light" data-aos="fade-right">
        <Container>
          <Navbar.Brand href="/">
            <img
              alt="Toku Logo"
              src="/static/img/brand.svg"
              width="64"
              height="64"
              className="d-inline-block align-top"
            /> {' '}
            <span className="logo" style={{ lineHeight: '64px' }}>Toku</span>
          </Navbar.Brand>
        </Container>
      </Navbar>
      </>
    )
  }
}

export default RealNavbar;
